import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63a9ab84"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sort-option-list" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "sort-option-list__heading" }, "Sort by:", -1 /* HOISTED */))

import { TProductKeys } from '@/services';
import { useSortOptionList, sortQueryKey } from '@/composables';
import SortOption from './SortOption.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SortOptionList',
  props: {
    sortKeys: null
  },
  setup(__props: any) {

const props = __props as {
  sortKeys: TProductKeys[],
};




useSortOptionList(props.sortKeys);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.sortKeys, (sortKey) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "sort-option-list__item",
        key: sortKey
      }, [
        _createVNode(SortOption, {
          "product-key": sortKey,
          "query-key": _unref(sortQueryKey)
        }, null, 8 /* PROPS */, ["product-key", "query-key"])
      ]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}
}

})